import { axiosHelper, POST_METHOD } from './helper'
import { RequestEmailLoginPayload, EmailLoginPayload, SocialLoginPayload } from './type'
import { ResetStatePayload } from '../modules/app/types'

export function requestSocialLogin(payload: SocialLoginPayload) {
  return axiosHelper(POST_METHOD, '/web/social-request-login', payload)
}

export function requestEmailLogin(payload: RequestEmailLoginPayload) {
  return axiosHelper(POST_METHOD, 'web/email-checker', payload)
}

export function emailLogin(payload: EmailLoginPayload) {
  return axiosHelper(POST_METHOD, 'web/login', payload)
}

export function resetState(payload: ResetStatePayload) {
  return axiosHelper(POST_METHOD, '/reset-state', payload)
}
